export type PreLoginHook = () => void | Promise<void>;

export function usePreLoginHooks() {
    const hooks = useState<PreLoginHook[]>('pre-login-hooks', () => []);

    const register = (fn: PreLoginHook) => {
        if (typeof fn === 'function' && !hooks.value.includes(fn)) {
            hooks.value.push(fn);
        }
    };

    const registerMany = (fns: PreLoginHook[] = []) => {
        for (const fn of fns) register(fn);
    };

    const runAll = async () => {
        const executions = hooks.value.map((fn) => {
            try {
                return Promise.resolve(fn());
            } catch (e) {
                return Promise.reject(e);
            }
        });
        await Promise.allSettled(executions);
    };

    return { register, registerMany, runAll };
}
